import React, { useEffect, useState } from "react";
import { FiPlusCircle, FiEdit3, FiCalendar, FiLayers } from "react-icons/fi";

import Dates from "./blockData/Dates";
import Insert from "./blockData/Insert";
import Update from "./blockData/Update";

const BlockDataInsertion = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [active, setActive] = useState("insert");
  const [dataChanged, setDataChanged] = useState(false);

  useEffect(() => {
    setActive(selectedDate?.insert ? "update" : "insert");
  }, [selectedDate]);

  const handleTabChange = (tab) => {
    setActive(tab);
  };

  return (
    <div
      className="container-fluid px-2 px-md-3 py-3"
      style={{ minHeight: "90vh", maxWidth: "100%" }}
    >
      {/* Page Header */}
      <div
        className="card border-0 shadow-sm mb-3"
        style={{ borderRadius: "14px", overflow: "hidden" }}
      >
        <div
          className="card-body p-3 p-md-4"
          style={{
            background:
              "linear-gradient(110deg, #063b87 0%, #0a57bb 65%, #087344 100%)",
          }}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
              style={{
                width: "46px",
                height: "46px",
                background: "rgba(255,255,255,0.16)",
                color: "#fff",
                fontSize: "23px",
              }}
            >
              <FiLayers />
            </div>

            <div>
              <h5 className="text-white fw-bold mb-1">Block Data Management</h5>
              <p className="text-white-50 small mb-0">
                Insert and update daily block records
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Date Selection */}
      <div className="mb-3">
        <Dates
          dataChanged={dataChanged}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />
      </div>

      {/* Insert / Update Panel */}
      <div
        className="card border-0 shadow-sm mb-3"
        style={{ borderRadius: "14px" }}
      >
        {/* Panel Header */}
        <div className="card-header bg-white border-bottom px-3 px-md-4 py-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
              <h6 className="fw-bold mb-1" style={{ color: "#16365c" }}>
                Block Records
              </h6>
              <small className="text-muted">
                Choose an action to manage block data
              </small>
            </div>

            {selectedDate?.date && (
              <span
                className="badge rounded-pill px-3 py-2"
                style={{
                  background: "#eaf2ff",
                  color: "#0a57bb",
                  fontSize: "12px",
                }}
              >
                <FiCalendar className="me-1" />
                {/* {selectedDate.date} */}
                {selectedDate.date.slice(8, 10)}-{selectedDate.date.slice(5, 7)}
                -{selectedDate.date.slice(0, 4)}
              </span>
            )}
          </div>
        </div>

        {/* Tabs */}
        <div className="card-body p-2 p-md-3">
          <div
            className="d-flex gap-2 p-1 rounded-3 mb-3"
            style={{ background: "#f1f5f9" }}
            role="tablist"
            aria-label="Block record actions"
          >
            <button
              type="button"
              role="tab"
              aria-selected={active === "insert"}
              onClick={() => handleTabChange("insert")}
              className="btn btn-sm flex-fill d-flex align-items-center justify-content-center gap-2 py-2"
              style={{
                borderRadius: "8px",
                fontWeight: 600,
                background: active === "insert" ? "#0a57bb" : "transparent",
                color: active === "insert" ? "#fff" : "#475569",
                border: "none",
                boxShadow:
                  active === "insert"
                    ? "0 2px 6px rgba(10,87,187,0.2)"
                    : "none",
              }}
            >
              <FiPlusCircle size={17} />
              Insert Data
            </button>

            <button
              type="button"
              role="tab"
              aria-selected={active === "update"}
              onClick={() => handleTabChange("update")}
              className="btn btn-sm flex-fill d-flex align-items-center justify-content-center gap-2 py-2"
              style={{
                borderRadius: "8px",
                fontWeight: 600,
                background: active === "update" ? "#087344" : "transparent",
                color: active === "update" ? "#fff" : "#475569",
                border: "none",
                boxShadow:
                  active === "update" ? "0 2px 6px rgba(8,115,68,0.2)" : "none",
              }}
            >
              <FiEdit3 size={17} />
              Update Data
            </button>
          </div>

          {/* Active Content */}
          <div className="pt-1">
            {active === "insert" ? (
              <div role="tabpanel">
                <Insert
                  selectedDate={selectedDate}
                  setDataChanged={setDataChanged}
                />
              </div>
            ) : (
              <div role="tabpanel">
                <Update
                  selectedDate={selectedDate}
                  setDataChanged={setDataChanged}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockDataInsertion;
